<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Woningen
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Een eigen woning is een koopwoning die je hoofdverblijf is. Een deel van de waarde van deze woning hoort
                bij je inkomen in box 1, maar je mag ook de rente en sommige kosten die je voor deze woning betaalt
                aftrekken van de inkomsten in box 1. Wij noemen dit de eigenwoningregeling.
                <div class="space10"></div>

                De eigenwoningregeling is van toepassing als je eigenaar was van een vroegere of toekomstige eigen
                woning in de volgende situaties:
                <li class="list">je bent verhuisd. Je oude woning stond leeg en was nog niet verkocht.</li>
                <li class="list">je hebt een woning gekocht die was bedoeld als je toekomstige hoofdverblijf.
                    Bijvoorbeeld een
                    bouwkavel, een leegstaande woning of een woning die nog in aanbouw was.
                </li>
                <li class="list">je bent verhuisd en je vroegere fiscale partner bleef in de woning.</li>
                <li class="list">je was opgenomen in een verzorgings- of verpleeghuis vanwege medische redenen of
                    ouderdom en je
                    hield de woning aan.
                </li>
                <li class="list">je was tijdelijk uitgezonden of overgeplaatst, waardoor de woning leegstond.</li>
                <div class="space10"></div>

                Let op! Onder 'woning' wordt ook verstaan een woonboot of woonwagen met een vaste lig- of
                standplaats. Het gaat hier niet om onroerende zaken die bij het ondernemingsvermogen horen.
                <div class="space10"></div>

                De eigenwoningregeling is niet van toepassing op:
                <li class="list">landgoederen (alleen de grond) in de zin van de Natuurschoonwet 1928.Ook als dit een
                    landgoed was in de EU of EER én erkend is als Nederlands cultureel erfgoed.
                </li>
                <li class="list">bossen</li>
                <li class="list">natuurterreinen</li>
                <div class="space10"></div>

                Wanneer is de eigenwoningregeling wel meer van toepassing?
                <li class="list">als sprake is van erfpacht, opstal, beklemming of appartementsrecht.</li>
                <li class="list">als je of je fiscale partner, of je samen, het vruchtgebruik, recht van bewoning of
                    recht van gebruik van de woning heeft geërfd. Je moet er dan wel zelf in wonen, en zelf de kosten
                    ervan betalen.
                </li>
                <li class="list">je hebt onroerende zaak geërfd, die nog niet verdeeld is onder de erfgenamen. Vul dan
                    hier ook je deel van die erfenis in.
                </li>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4"
                    aria-expanded="false" aria-controls="collapse4">
                Aanhorigheden
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Een bijgebouw of stuk grond kan ook bij uw eigen woning horen, zoals een garage. We noemen dit een
                aanhorigheid. Een aanhorigheid voldoet aan de volgende 3 voorwaarden:
                <li>de aanhorigheid hoort bij de eigen woning.</li>
                <li>De aanhorigheid is in gebruik bij de woning.</li>
                <li>De aanhorigheid is dienstbaar aan de eigen woning.</li>
                Hoort een aanhorigheid bij de eigen woning? Dan telt de WOZ-waarde van de aanhorigheid mee voor de
                waarde van de woning.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2"
                    aria-expanded="false" aria-controls="collapse2">
                Fiscale partners en ieder een eigen woning
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Hebben aangever en de fiscale partner ieder een woning? En gebruiken beiden de woning als hoofdverblijf?
                Dan moeten ze samen kiezen welke van deze 2 woningen als hoofdverblijf gold voor de eigenwoningregeling.
                De waarde van de andere woning en de schuld die daarbij hoort, hoort in aangever aangifte in box 3
                (sparen en beleggen). Als ze duurzaam gescheiden leven, kunnen ze wél 2 eigen woningen hebben.
                <div class="space10"></div>

                Zijn ze tijdens het jaar fiscale partners geworden? Dan gaat de keuze welke woning het hoofdverblijf
                wordt voor de eigenwoningregeling in vanaf de datum waarop ze fiscale partners zijn geworden. Ook als ze
                ervoor kiezen om het hele jaar als fiscale partners te worden beschouwd.
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3"
                    aria-expanded="false" aria-controls="collapse3">
                Kinderen als mede-eigenaren van de woning
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Als één of meerdere van de kinderen na overlijden van de partner een deel van de woning hebben geërfd,
                aangever diegene is die erin woont en hij de kosten en lasten draagt van de woning, dan mag hij de
                woning aangeven als enige eigenaar. De kinderen geven de woning niet aan in hun aangifte.
            </div>
        </div>
    </div>

</div>
